import request from '@/request/ts-index';
var ConfigApi;
(function (ConfigApi) {
    ConfigApi["queryConfig"] = "/config/query";
    ConfigApi["queryRule"] = "/config/rule";
})(ConfigApi || (ConfigApi = {}));
export const getConfig = () => {
    return request.get(ConfigApi.queryConfig, {});
};
export const getRule = () => {
    return request.get(ConfigApi.queryRule, {});
};
